import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    // Можно отправить ошибку на сервер или логировать
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: 40,
          textAlign: 'center',
          background: '#fff',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <div style={{ fontSize: 64, marginBottom: 16 }}>😥</div>
          <h1 style={{ fontSize: 32, marginBottom: 16 }}>Что-то пошло не так</h1>
          <p style={{ fontSize: 18, marginBottom: 32, color: '#666' }}>
            Произошла непредвиденная ошибка. Пожалуйста, попробуйте обновить страницу.<br/>
            Если ошибка повторяется, обратитесь в поддержку.
          </p>
          <button
            onClick={this.handleReload}
            style={{
              padding: '12px 32px',
              fontSize: 18,
              background: '#2563eb',
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              cursor: 'pointer',
              marginBottom: 24,
            }}
          >
            Обновить страницу
          </button>
          {/* Для разработчиков: подробности ошибки */}
          <details style={{ whiteSpace: 'pre-wrap', color: 'gray', marginTop: 24 }}>
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.errorInfo && this.state.errorInfo.componentStack}
          </details>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary; 